import { createApi } from '@reduxjs/toolkit/query/react';
import { createAccountGSTDetails, createAccountMaster, createAccountMasterCustom, createBankDetails, deleteAccountMaster, getAccountGSTDetails, listAccountMasterv2Custom, listaccountopeningbalancev2, updateAccountMaster } from '../../graphql';
import { baseQuery } from '../baseQuery';

export const listAccountMasterv2Api = createApi({
    reducerPath: 'listAccountMasterv2',
    baseQuery: baseQuery,
    tagTypes:['listAccountMaster'],
    endpoints: (builder) => ({
        listAccountMasterv2: builder.query({
            query: () => ({ body: listAccountMasterv2Custom }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['listAccountMaster', 'allaccounts'],
        }),

        getAccountGSTDetailsData: builder.query({
            query: (variables) => ({ body: getAccountGSTDetails, variables }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['accountGSTDetails'],
        }),

        createAccountMaster: builder.mutation({
            query: (variables) => ({ body: createAccountMasterCustom, variables }),
            invalidatesTags: ['dashboard', 'listAccountMaster', 'allaccounts'],
        }),
        createAccountGSTDetails: builder.mutation({
            query: (variables) => ({ body: createAccountGSTDetails, variables }),
        }),
        createBankDetails: builder.mutation({
            query: (variables) => ({ body: createBankDetails, variables }),
            invalidatesTags: ['listAccountMaster'],
        }),
        updateAccountMaster: builder.mutation({
            query: (variables) => ({ body: updateAccountMaster, variables }),
            invalidatesTags: ['listAccountMaster', 'allaccounts'],
        }),
        deleteAccountMaster: builder.mutation({
            query: (variables) => ({ body: deleteAccountMaster, variables }),
            invalidatesTags: ['dashboard', 'listAccountMaster', 'allaccounts'],
        }),
    }),
});

export const { useListAccountMasterv2Query, useLazyListAccountMasterv2Query, useCreateAccountMasterMutation, useCreateAccountGSTDetailsMutation, useCreateBankDetailsMutation, useUpdateAccountMasterMutation, useGetAccountGSTDetailsDataQuery, useDeleteAccountMasterMutation } = listAccountMasterv2Api;
